<template>
  <div class="flex flex-col flex-wrap">
    <div class="p-0 md:p-4 flex flex-col h-full">
      <div class="mb-8 shrink-0 grow-0 flex-auto">
        <h3 class="font-bold text-md">
          {{ $t('Components.RatingCommentsList.title') }}
        </h3>
      </div>
      <div class="flex flex-col overflow-y-auto item-container">
        <Card
          v-for="comment in filteredComments"
          :key="comment.CreatedOn"
          class="item p-2 flex justify-between"
        >
          <div
            class="text flex flex-col flex-grow-1 shrink-1"
            :class="{ 'opacity-25': comment.isHidden }"
          >
            <div class="time text-xs mb-2 font-bold text-dark">
              <Moment
                :value="comment.CreatedOn"
                format="YYYY-MM-DD HH:mm:ss"
                :is-offset="false"
              />
            </div>
            <div>
              <span>{{ comment.comment || comment.Comment }}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '../shared/Card.vue';
export default {
  props: {
    poll: Object
  },
  components: {
    Card
  },
  computed: {
    filteredComments() {
      return this.poll.comments?.filter(
        (item) => item.comment !== '' && item.comment !== null
      );
    }
  }
};
</script>

<style scoped lang="scss">
.item-container {
  height: 45vh;
  overflow-y: auto;
}

.item {
  .time {
    color: #888;
  }

  .button-primary {
    background: #52cdda;
    border-color: #52cdda;
    color: #fff;
  }

  .button-secondary {
    background: #720600;
    border-color: #720600;
    color: #fff;
  }
}
</style>
